module.exports = "/images/logo.svg?23edebaa3e33c2d589eecde52d3e41fb";